import { render, staticRenderFns } from "./VatNumberModal.vue?vue&type=template&id=b4e753d0&scoped=true"
import script from "./VatNumberModal.vue?vue&type=script&lang=js"
export * from "./VatNumberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e753d0",
  null
  
)

export default component.exports